import { CardBlog } from './CardBlog';

export type { TypeCardBlogProps } from './types';
export default CardBlog;
